

//
export const ALL_ANIMAL_LISTING = 'ALL_ANIMAL_LISTING'
export const ALL_ANIMAL_LISTING_SUCCESS = 'ALL_ANIMAL_LISTING_SUCCESS'
